export default {"src":"/_next/static/media/closeSvg.5128e22c.svg","height":24,"width":24};